export enum ActionType {
	HideQuestion = 1,
	ShowQuestion = 2,
	BranchToQuestion = 3,
	// The below values are future scope and have not been implemented yet.
	// GoToSurveyEnd = 4,
	// RedirectToUrl = 5,
	// HideResponseOption = 6,
	// AlternateFinishText = 7,
}
